import { Injectable } from '@angular/core';
import { from } from 'rxjs';
import { PortalSessionService } from './portal-session.service';

@Injectable({
    providedIn: 'root'
})
export class AuthService {
    constructor(private sessions: PortalSessionService) {}

    public login(cpf: string, senha: string) {
        return from(this.sessions.login(cpf, senha));
    }
}
